import React from "react";
import { useIntl } from "react-intl";
import { Grid, ThreeDots, Circles, Bars } from "react-loader-spinner";

function Loader() {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] pt-24 px-4 sm:px-6 lg:px-8">
      {/* Animated container */}
      <div className="relative">
        {/* Background gradient effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#16A34A] to-[#0a1628] rounded-full blur-xl opacity-30 animate-pulse"></div>

        {/* Main loader */}
        <div className="relative bg-white rounded-full p-8 shadow-2xl">
          <Grid
            height="60"
            width="60"
            color="#16A34A"
            ariaLabel="grid-loading"
            radius="12.5"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      </div>

      {/* Loading text with animation */}
      <div className="mt-8 text-center">
        <div className="flex items-center space-x-2">
          <span className="text-gray-700 font-medium text-lg">
            {intl.formatMessage({ id: "loading", defaultMessage: "Loading" })}
          </span>
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-[#16A34A] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-[#16A34A] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-[#16A34A] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="mt-4 w-48 h-1 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#16A34A] to-[#15803D] rounded-full animate-pulse" style={{
            animation: 'slide 2s ease-in-out infinite'
          }}></div>
        </div>

        {/* Subtitle */}
        <p className="mt-2 text-sm text-gray-500">
          {intl.formatMessage({ id: "please.wait", defaultMessage: "Please wait..." })}
        </p>
      </div>

      {/* Secondary decorative elements */}
      <div className="flex space-x-4 mt-6">
        <Circles
          height="20"
          width="20"
          color="#e5e7eb"
          ariaLabel="circles-loading"
          visible={true}
        />
        <Bars
          height="20"
          width="20"
          color="#e5e7eb"
          ariaLabel="bars-loading"
          visible={true}
        />
        <ThreeDots
          height="20"
          width="20"
          color="#e5e7eb"
          ariaLabel="three-dots-loading"
          visible={true}
        />
      </div>

      {/* Custom styles */}
      <style>{`
        @keyframes slide {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }
      `}</style>
    </div>
  );
}

export default Loader;
